const DEFAULT_LABELS = {
    add: 'Bookmark page',
    remove: 'Delete bookmark',
};
const DEFAULT_TOAST_COPY = {
    errorTitle: "We couldn't update your bookmark",
    errorMessage: 'Please try again.',
    signInTitle: 'Sign in to bookmark this page',
    signInMessage: 'You need to be signed in to save pages to your bookmarks.',
    addedAnnouncement: 'Page bookmarked',
    removedAnnouncement: 'Bookmark removed',
    closeLabel: 'Close notification',
    durationMs: 6000,
};
function parseCopy(value, defaults) {
    if (!value)
        return defaults;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === 'object'
            ? Object.assign(Object.assign({}, defaults), parsed) : defaults;
    }
    catch (_a) {
        return defaults;
    }
}

export { DEFAULT_LABELS, DEFAULT_TOAST_COPY, parseCopy };
